import { CurrencyFormat, formatDate } from "../../../../components/helpers";

export const convertGadaiReport = (gadaiReports, handleOpenPreview) => {
  let convertedGadaiReports = [];

  if (!gadaiReports) return [];

  gadaiReports.forEach((gadai, index) => {
    let promoUsed = []
    if (gadai.gadai_promo_loan != null){
      promoUsed = [
        `${gadai.gadai_promo_loan.name} (${
          gadai.gadai_promo_loan.is_default ? "reguler" : "promo"
        } offer)`,
      ];
    }
    if (gadai.gadai_extensions.length > 0) {
      gadai.gadai_extensions.forEach((extension, index) => {
        if (extension.promo_extension == null) {
          promoUsed.push("(Auto)");
        } else {
          promoUsed.push(
            `${extension.promo_extension.name} (${
              extension.promo_extension.is_default ? "reguler" : "promo"
            } offer)`
          );
        }
      });
    }

    const receipts = gadai.receipts
      .map((receipt) => receipt.receipt_number)
      .join(", ");

    const convertedGadaiExts = {
      initialCapitalLease: [],
      promoCapitalLease: [],
      initialAdminFee: [],
      promoAdminFee: [],
      initialStoreAndInsurance: [],
      promoStoreAndInsurance: [],
      initialRevaluation: [],
      promoRevaluation: [],
    };

    gadai.gadai_extensions.forEach((ext) => {
      convertedGadaiExts.initialCapitalLease.push(
        `Rp ${CurrencyFormat(ext.capital_loan_default) || 0}`
      );
      convertedGadaiExts.promoCapitalLease.push(
        `Rp ${CurrencyFormat(ext.capital_loan_promo) || 0}`
      );
      convertedGadaiExts.initialAdminFee.push(
        `Rp ${CurrencyFormat(ext.fee_admin_default) || 0}`
      );
      convertedGadaiExts.promoAdminFee.push(
        `Rp ${CurrencyFormat(ext.fee_admin_promo) || 0}`
      );
      convertedGadaiExts.initialStoreAndInsurance.push(
        `Rp ${CurrencyFormat(ext.fee_saving_assurance_default) || 0}`
      );
      convertedGadaiExts.promoStoreAndInsurance.push(
        `Rp ${CurrencyFormat(ext.fee_saving_assurance_promo) || 0}`
      );
      convertedGadaiExts.initialRevaluation.push(
        `Rp ${CurrencyFormat(ext.revaluation_default) || 0}`
      );
      convertedGadaiExts.promoRevaluation.push(
        `Rp ${CurrencyFormat(ext.revaluation_promo) || 0}`
      );
    });

    convertedGadaiReports.push({
      key: index + 1,
      gadaiID: gadai.id || "-",
      dateTime: formatDate(gadai.transaction_time) || "-",
      pawnNumber: gadai.sbg_code || "-",
      receiptNumber: receipts || "-",
      gadaiCode: gadai.sbg_code || "-",
      customerName: gadai.customer_name || "-",
      category: gadai.product_category || "-",
      paymentType: gadai.payment_type || "-",
      tenorType: gadai.tenor_type || "-",
      tenor:
        `${gadai.tenor_days} hari (${Math.floor(
          gadai.tenor_days / 30
        )} bulan)` || "-",
      valuationValue:
        `Rp ${CurrencyFormat(gadai.valuation_amount) || 0}` || "-",
      amountReceived: `Rp ${CurrencyFormat(gadai.taken_amount) || 0}` || "-",
      initialCapitalLease:
        `Rp ${CurrencyFormat(gadai.capital_loan_default) || 0}` || "-",
      promoCapitalLease:
        `Rp ${CurrencyFormat(gadai.capital_loan_promo) || 0}` || "-",
      initialAdminFee:
        `Rp ${CurrencyFormat(gadai.fee_admin_default) || 0}` || "-",
      promoAdminFee: `Rp ${CurrencyFormat(gadai.fee_admin_promo) || 0}` || "-",
      initialStoreAndInsurance:
        `Rp ${CurrencyFormat(gadai.fee_saving_assurance_default) || 0}` || "-",
      promoStoreAndInsurance:
        `Rp ${CurrencyFormat(gadai.fee_saving_assurance_promo) || 0}` || "-",
      transferAmount: `Rp ${CurrencyFormat(gadai.fee_transfer) || 0}` || "-",
      initialCapitalLeaseExtension:
        convertedGadaiExts.initialCapitalLease?.join(", ") || "-",
      promoCapitalLeaseExtension:
        convertedGadaiExts.promoCapitalLease?.join(", ") || "-",
      initialAdminFeeExtension:
        convertedGadaiExts.initialAdminFee?.join(", ") || "-",
      promoAdminFeeExtension:
        convertedGadaiExts.promoAdminFee?.join(", ") || "-",
      initialStoreAndInsuranceExtension:
        convertedGadaiExts.initialStoreAndInsurance?.join(", ") || "-",
      promoStoreAndInsuranceExtension:
        convertedGadaiExts.promoStoreAndInsurance?.join(", ") || "-",
      initialRevaluationValue:
        convertedGadaiExts.initialRevaluation?.join(", ") || "-",
      promoRevaluationValue:
        convertedGadaiExts.promoRevaluation?.join(", ") || "-",
      lateFee: `Rp ${CurrencyFormat(gadai.fee_late) || 0}` || "-",
      lateStorage: `Rp ${CurrencyFormat(gadai.fee_late_saving) || 0}` || "-",
      deliveryFee: `Rp ${CurrencyFormat(gadai.fee_shipping) || 0}` || "-",
      auctionService: `Rp ${CurrencyFormat(gadai.fee_auction) || 0}` || "-",
      refund: `Rp ${CurrencyFormat(gadai.cashback_amount) || 0}` || "-",
      excessAuction:
        `Rp ${CurrencyFormat(gadai.remaining_auction_money) || 0}` || "-",
      totalPayment: `Rp ${CurrencyFormat(gadai.loan_amount) || 0}` || "-",
      itemAuctionPrice: `Rp ${CurrencyFormat(gadai.auction_price) || 0}` || "-",
      status: gadai.status || "-",
      promoUsed,
    });
  });
  return convertedGadaiReports;
};
